import React, { useState } from 'react'

import moment from 'moment'
import { DatePicker, Modal, Checkbox, Button } from 'antd'
import { faFileExport } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import IconButton from '../../antd/Buttons/IconButton'
import { API_DATE } from '../../../utils/momentjs'

const WeekPicker = DatePicker.WeekPicker

const ExportInternshipsModal = ({ endDate, filters, startDate, isVisible, afterClose, onCancel, onExport }) => {
  const t = useSelector(selectTranslate)

  const [_startDate, setStartDate] = useState(startDate ?? moment())
  const [_endDate, setEndDate] = useState(endDate ?? moment())
  const [checked, setChecked] = useState(false)

  const handleExport = () => {
    onExport({ startDate: _startDate.format(API_DATE), endDate: _endDate.format(API_DATE), checked })
  }

  return (
    <Modal
      destroyOnClose
      afterClose={afterClose}
      onCancel={onCancel}
      title={t('Export timeline')}
      visible={isVisible}
      footer={[
        <Button key='cancel' onClick={onCancel}>{t('Cancel')}</Button>,
        <IconButton type='primary' key='export' icon={faFileExport} text={t('Export')} onClick={handleExport} />
      ]}
    >
      <div className='flex-column'>
        {t('Start date')}
        <WeekPicker value={_startDate} format='DD/MM/YYYY' onChange={setStartDate} />
        <div className='v-spacing' />
        {t('End date')}
        <WeekPicker value={_endDate} format='DD/MM/YYYY' onChange={setEndDate} />
        <div className='v-spacing' />
        <Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)}>
          {t('Use current filters')}
        </Checkbox>
      </div>
    </Modal>
  )
}

export default ExportInternshipsModal
